import { App } from '@capacitor/app';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { Credentials, NativeBiometric } from "capacitor-native-biometric";
import OneSignal, { NotificationClickEvent } from 'onesignal-cordova-plugin';

// Utils
import { isDefined } from 'src/app/platform/utils/functions';
import { UiDialogComponent } from 'src/app/platform/components/ui-dialog/ui-dialog.component';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DeviceService {
    public linkOpened = new BehaviorSubject<string>('');

    constructor(
        private router: Router,
        private uiDialog: MatDialog,
    ) {
        console.log('deviceSettings', this.deviceSettings);
    }

    get deviceSettings(): any {
        return JSON.parse(localStorage.getItem('deviceSettings') || '{}');
    }

    set deviceSettings(value: { [key: string]: any }) {
        const data = { ...this.deviceSettings, ...value};

        console.log(this.deviceSettings);
        
        localStorage.setItem('deviceSettings', JSON.stringify(data));
    }

    init(){
        this.notifications();

        App.addListener('appUrlOpen', (event) => {
            this.linkOpened.next(new URL(event.url).pathname);
        });
    }

    get biometricAvailable():boolean {
        return this.deviceSettings?.biometric?.login ?? false;
    }

    async biometricVerification(){
        //if (!Capacitor.isNativePlatform()) return;

        const result = await NativeBiometric.isAvailable();
        
        if(!result.isAvailable) return;
        
        return await NativeBiometric.verifyIdentity({
            reason: 'Verificación biométrica',
            title: 'Verificá tu identidad',
            subtitle: 'Usa tu huella digital para verificar tu identidad.',
            maxAttempts: 3,
            negativeButtonText: 'Cancelar'
        }).then(() => true).catch(() => false);
    }

    async biometricSetCredentials(username: string, password: string, server: string = environment.apiUrl){
        if(!Capacitor.isNativePlatform()) return;

        if (
            this.deviceSettings?.biometric?.login !== true &&
            this.deviceSettings?.biometric?.ask !== false
        ) {
            this.uiDialog.open(UiDialogComponent, {
                width: '250px',
                data: {
                    title: 'Añadir ingreso rápido',
                    message: '¿Queres añadir el inicio de sesión rápido mediante tus datos biométricos?',
                    buttonCancelText: 'No',
                    buttonConfirmText: 'Si, Añadir',
                    action: () => {
                        this.biometricVerification().then((verified: boolean | undefined) => {
                            if(verified === true){
                                this.deviceSettings = { biometric: { login: true }};
                                
                                NativeBiometric.setCredentials({ username, password, server }).then().catch(error => {
                                    this.biometricDeleteCredentials(server);
                
                                    return false;
                                });
                            }
                        });
                        
                    }
                }
            });
        }
    }

    async biometricDeleteCredentials(server: string = environment.apiUrl){
        if(!Capacitor.isNativePlatform()) return;

        this.deviceSettings = { biometric: { login: false }};
        NativeBiometric.deleteCredentials({ server }).then();
    }

    biometricGetCredentials(server: string = environment.apiUrl): Promise<Credentials|false|undefined> {
       if(!Capacitor.isNativePlatform()) return Promise.resolve(undefined);
        
       return this.biometricVerification().then(async (verified: boolean | undefined) => {
            if(verified === true){
                return await NativeBiometric.getCredentials({ server }).catch(error => {
                    this.biometricDeleteCredentials(server);

                    return false;
                });
            } else {
                return false;
            }
        })
    }

    notifications(){
        if (Capacitor.isNativePlatform()) {
            document.addEventListener('deviceready', () => {
                OneSignal.initialize(environment.oneSignalAppId);

                OneSignal.Notifications.addEventListener('click', async (event: NotificationClickEvent) => {
                    console.log('Notification opened:', event);
                    
                    let data = await event.notification;                    

                    if(isDefined(data.additionalData)){
                        this.run(data.additionalData);
                    }
                })

                OneSignal.Notifications.requestPermission(true).then((success: Boolean) => {
                    console.log('Notification permission granted ' + success);
                })
            });
        } else {
            console.log('OneSignal not available in web browser.');
        }
    }

    notificationsSetUser(userId: number){
        if(typeof OneSignal !== 'undefined' && Capacitor.isNativePlatform()){
            console.log('OneSignal', 'Set external user ' + userId);

            OneSignal.login(String(userId));
        };
    }

    notificationsRemoveUser(){
        if(typeof OneSignal !== 'undefined' && Capacitor.isNativePlatform()){
            console.log('OneSignal', 'Remove external user');

            OneSignal.logout();
        };
    }

    run(actions: any){
        let screen: any = [];
        let parameters = {};

        console.log('OneSignal run actions:', actions);

        if(typeof actions.screen != 'undefined' && actions.screen !== ''){
            if(actions.Pantalla === 'x'){
                
            }

            if(isDefined(screen)){
                this.router.navigate(screen, { queryParams: parameters });
            }
        }
    }
}
